import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL, { api1 } from "../../utils/Url";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import { usePermissionData } from "../../usePermissionData";
import DeleteIcon from "@mui/icons-material/Delete";
import { Chip, FormControl, FormLabel } from "@mui/material/node";

interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}

export default function StockVerification() {
    const { i18n, t } = useTranslation();
    const [columns, setColumns] = useState<any>([]);
    const [rows, setRows] = useState<any>([]);
    const [editId, setEditId] = useState("-1");
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [quertOpt, setQuertOpt] = useState([]);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });
    const navigate = useNavigate();

    useEffect(() => {

        getbooklocation();
    }, []);
    const getbooklocation = () => {

        const collectData = {
            "epc": "",
            "type": 4
        };
        console.log("collectData " + JSON.stringify(collectData));
        api1
            .post(`MasterForm/GetBookDetails`, collectData)
            .then((response) => {
                const data = response.data.result

                const resp = data.map((item: any, index: any) => ({
                    value: item?.accessionid,
                    label: item?.loc_id || "",

                }))

                setQuertOpt(resp);

            });
    };

    const getList = () => {
        setLoading(true)
        const collectData = {
            "locationId": formik.values.locationID,
            "almirahEpc": "",
            "bookEPC": "",
            "mached": formik.values.mached,
            // "mached": formik.values.mached === true ? "m" : "s",
            "status": "",
            "type": 2
        };
        try {
            api1
                .post(`MasterForm/MatchedBookList`, collectData)
                .then((res) => {
                    console.log("result" + JSON.stringify(res.data.result));
                    const data = res.data.result;
                    const arr = data.map((item: any, index: any) => ({
                        ...item,
                        serialNo: index + 1,
                        id: index + 1,

                    }));
                    console.log(arr)
                    setRows(arr);
                    setIsLoading(false);
                    setShow(true)
                    setLoading(false)
                    if (data.length > 0) {
                        const columns: GridColDef[] = [

                            {
                                field: "serialNo",
                                headerName: t("text.SrNo"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                            },
                            {
                                field: "accNo",
                                headerName: t("text.Acceno"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                            },

                            {
                                field: "title",
                                headerName: t("text.title"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                            },
                            {
                                field: "locationName",
                                headerName: t("text.location"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                            },
                            {
                                field: "status",
                                headerName: t("text.status"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                            },

                        ];
                        setColumns(columns as any);
                    }
                });
            // setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            // setIsLoading(false);
        }
    };

    const [toaster, setToaster] = useState(false);
    const formik = useFormik({
        initialValues: {
            locationID: "",
            mached: "m"
        },

        onSubmit: async (values: any) => {

            console.log("check", values);

        },
    });

    const requiredFields = ["queryType"];


    const routeChangeEdit = (row: any) => {
        formik.setFieldValue("queryType", row.queryType);
        formik.setFieldValue("queryDetail", row.queryDetail);
        formik.setFieldValue("status", row.status);

        setEditId(row.id);
    };

    return (
        <>
            <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mt: "3vh" }}>
                <Card
                    sx={{
                        width: "100%",
                        backgroundColor: "#E9FDEE",
                        border: ".5px solid #FF7722",
                        mt: "5px",
                    }}
                >
                    <Paper
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            p: 2,
                            "& .MuiDataGrid-colCell": {
                                backgroundColor: "#2B4593",
                                color: "#fff",
                                fontSize: 18,
                                fontWeight: 800,
                            },
                        }}
                    >
                        <ConfirmDialog />

                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            sx={{ px: 2, pt: 2 }}
                            align="left"
                        >
                            {t("text.StockVerification")}
                        </Typography>

                        <Divider />
                        <Box height={10} />

                        <Stack spacing={2}>
                            <form onSubmit={formik.handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={quertOpt}
                                            fullWidth
                                            size="small"
                                            sx={{ backgroundColor: "white" }}
                                            onChange={(event, newValue: any) => {
                                                formik.setFieldValue("locationID", newValue?.value);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={
                                                        <span>{t("text.SelectLocationNo")}</span>
                                                    }
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl component="fieldset" fullWidth>
                                            <Box display="flex" flexWrap="wrap" alignItems="center">
                                                <FormLabel
                                                    component="legend"
                                                    sx={{ mr: 2, fontWeight: 600, minWidth: "75px" }}
                                                >
                                                    Status :-
                                                </FormLabel>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={formik.values.mached === "m"}
                                                            onChange={() =>
                                                                formik.setFieldValue(
                                                                    "mached",
                                                                    formik.values.mached === "m" ? "" : "m"
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Issue"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={formik.values.mached === "s"}
                                                            onChange={() =>
                                                                formik.setFieldValue(
                                                                    "mached",
                                                                    formik.values.mached === "s" ? "" : "s"
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Missing"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={formik.values.mached === "f"}
                                                            onChange={() =>
                                                                formik.setFieldValue(
                                                                    "mached",
                                                                    formik.values.mached === "f" ? "" : "f"
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Found"
                                                />
                                            </Box>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={1} display="flex" justifyContent="center" alignItems="center">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            fullWidth
                                            onClick={(e: any) => {
                                                e.preventDefault();
                                                getList();
                                            }}
                                        >
                                            {loading ? (
                                                <CircularProgress size={24} sx={{ color: "white" }} />
                                            ) : (
                                                "Show"
                                            )}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Stack>

                        {show && (
                            <>
                                {isLoading ? (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{ py: 4 }}
                                    >
                                        <CircularProgress />
                                    </Box>
                                ) : (
                                    <Box sx={{ width: "100%", backgroundColor: "#FFFFFF", mt: 2 }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            autoHeight
                                            pagination
                                            rowSpacingType="border"
                                            pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                                                value: size,
                                                label: `${size}`,
                                            }))}
                                            initialState={{
                                                pagination: { paginationModel: { pageSize: 5 } },
                                            }}
                                            slots={{
                                                toolbar: GridToolbar,
                                            }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                            sx={{
                                                "& .MuiDataGrid-columnHeaders": {
                                                    minHeight: "40px !important",
                                                    maxHeight: "40px !important",
                                                },
                                                "& .MuiDataGrid-columnHeaderTitle": {
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                },
                                            }}
                                        />
                                    </Box>
                                )}
                            </>
                        )}
                    </Paper>
                </Card>
            </Grid>
            <ToastApp />
        </>

    );
}
